/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetTeacherClaimedFreeResourcesR200ResponseCoursesInnerFromJSON, GetTeacherClaimedFreeResourcesR200ResponseCoursesInnerToJSON, } from './GetTeacherClaimedFreeResourcesR200ResponseCoursesInner';
import { GetTeacherClaimedFreeResourcesR200ResponseTimeSpanFromJSON, GetTeacherClaimedFreeResourcesR200ResponseTimeSpanToJSON, } from './GetTeacherClaimedFreeResourcesR200ResponseTimeSpan';
/**
 * @export
 */
export const GetTeacherClaimedFreeResourcesR200ResponsePremiumSubjectsEnum = {
    Math: 'math',
    Ela: 'ela',
    SocialStudies: 'social_studies',
    Science: 'science'
};
/**
 * Check if a given object implements the GetTeacherClaimedFreeResourcesR200Response interface.
 */
export function instanceOfGetTeacherClaimedFreeResourcesR200Response(value) {
    if (!('courses' in value) || value['courses'] === undefined)
        return false;
    if (!('maxFreeResourcesPerCourse' in value) || value['maxFreeResourcesPerCourse'] === undefined)
        return false;
    if (!('premiumSubjects' in value) || value['premiumSubjects'] === undefined)
        return false;
    if (!('timeSpan' in value) || value['timeSpan'] === undefined)
        return false;
    return true;
}
export function GetTeacherClaimedFreeResourcesR200ResponseFromJSON(json) {
    return GetTeacherClaimedFreeResourcesR200ResponseFromJSONTyped(json, false);
}
export function GetTeacherClaimedFreeResourcesR200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'courses': (json['courses'].map(GetTeacherClaimedFreeResourcesR200ResponseCoursesInnerFromJSON)),
        'maxFreeResourcesPerCourse': json['maxFreeResourcesPerCourse'],
        'premiumSubjects': json['premiumSubjects'],
        'timeSpan': GetTeacherClaimedFreeResourcesR200ResponseTimeSpanFromJSON(json['timeSpan']),
    };
}
export function GetTeacherClaimedFreeResourcesR200ResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'courses': (value['courses'].map(GetTeacherClaimedFreeResourcesR200ResponseCoursesInnerToJSON)),
        'maxFreeResourcesPerCourse': value['maxFreeResourcesPerCourse'],
        'premiumSubjects': value['premiumSubjects'],
        'timeSpan': GetTeacherClaimedFreeResourcesR200ResponseTimeSpanToJSON(value['timeSpan']),
    };
}
